module.exports = __webpack_public_path__ + "static/media/ninaru.e0d9c01c.svg";